// extracted by mini-css-extract-plugin
export default {"animatedButtonContainer":"animatedButtonContainer__ZjBmZ","animatedButton":"animatedButton__Yzk5O"};